<template>
  <div>
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'article', include: 3, 'fields.slug': this.$route.params.slug }"
      :key-path="[`article-${this.$route.params.slug}`]"
    />
    <loading
      v-if="status==='loading'"
      :rotate="true"
    />
    <img
      :src="imgMeta && `${imgMeta.file.url}?q=80`"
      alt="">
    <div class="v-content-container">
      <article-content
        :includes="includes"
        v-if="article"
        :me="me"
        :article="article"/>
    </div>
  </div>
</template>
<style scoped lang="scss">
.v-content-container {
  margin-top: 50px;
  @media screen and (max-width: 400px) {
    margin-top: 0;
    padding-top: 0;
  }
}
img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
</style>
<script>
import { mapState } from "vuex";
import ArticleContent from "./article";
import { getAsset } from "../../utils/contentful";
import { getApiData } from "vuex-api";

export default {
  components: { ArticleContent },
  name: "ArticleIndex",
  computed: mapState({
    article(state) {
      return (
        state.vuexApi[`article-${this.$route.params.slug}`] &&
        state.vuexApi[`article-${this.$route.params.slug}`].resp.data.items[0]
      );
    },
    status(state) {
      return (
        state.vuexApi[`article-${this.$route.params.slug}`] &&
        state.vuexApi[`article-${this.$route.params.slug}`].status
      );
    },
    me: getApiData("me"),
    includes(state) {
      return (
        state.vuexApi[`article-${this.$route.params.slug}`] &&
        state.vuexApi[`article-${this.$route.params.slug}`].resp.data.includes
      );
    },
    imgMeta: function() {
      return (
        this.article &&
        getAsset(this.includes, this.article.fields.coverImg.sys.id).fields
      );
    }
  })
};
// ${$route.params.slug}
</script>
<style>
</style>
